import { createSlice } from '@reduxjs/toolkit';
import {
  createEntry,
  createReply,
  deleteEntry,
  getDetailDiscussion,
  getFullDiscussionEntries,
  updateEntry,
} from './discussionThunk';
import { IDiscussionDetail, IDiscussionEntry } from '~/utils/interface/discussion';

interface DiscussionState {
  discussionDetail?: IDiscussionDetail;
  isLoading: boolean;
  errorMessage?: string;
  isLoadingEntries: boolean;
  isLoadingCreateEntry: boolean;
  isLoadingCreateReply: boolean;
  errorMessageEntry?: string;
  discussionEntries: IDiscussionEntry[];
  isRefreshList: boolean;
}

const initialState: DiscussionState = {
  isLoading: false,
  isLoadingEntries: false,
  isLoadingCreateEntry: false,
  isLoadingCreateReply: false,
  isRefreshList: false,
  discussionEntries: [],
};

const discussionSlice = createSlice({
  name: 'discussionSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Detail Discussion
    builder
      .addCase(getDetailDiscussion.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = undefined;
      })
      .addCase(getDetailDiscussion.fulfilled, (state, action) => {
        state.discussionDetail = action.payload.data;
        state.isLoading = false;
        state.errorMessage = undefined;
      })
      .addCase(getDetailDiscussion.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
      });

    // Get Full Discussion Entries
    builder
      .addCase(getFullDiscussionEntries.pending, (state) => {
        state.isLoadingEntries = true;
        state.errorMessageEntry = undefined;
      })
      .addCase(getFullDiscussionEntries.fulfilled, (state, action) => {
        state.discussionEntries = action.payload.data;
        state.isLoadingEntries = false;
        state.errorMessageEntry = undefined;
      })
      .addCase(getFullDiscussionEntries.rejected, (state, action) => {
        state.isLoadingEntries = false;
        state.errorMessageEntry = action.error.message;
      });

    // Create entry
    builder
      .addCase(createEntry.pending, (state) => {
        state.isLoadingCreateEntry = true;
      })
      .addCase(createEntry.fulfilled, (state, action) => {
        state.isLoadingCreateEntry = false;
        state.isRefreshList = !state.isRefreshList;
      })
      .addCase(createEntry.rejected, (state, action) => {
        state.isLoadingCreateEntry = false;
      });

    // Update entry
    builder
      .addCase(updateEntry.pending, (state) => {
        state.isLoadingCreateEntry = true;
      })
      .addCase(updateEntry.fulfilled, (state, action) => {
        state.isLoadingCreateEntry = false;
        state.isRefreshList = !state.isRefreshList;
      })
      .addCase(updateEntry.rejected, (state, action) => {
        state.isLoadingCreateEntry = false;
      });

    // Create reply
    builder
      .addCase(createReply.pending, (state) => {
        state.isLoadingCreateReply = true;
      })
      .addCase(createReply.fulfilled, (state, action) => {
        state.isLoadingCreateReply = false;
        state.isRefreshList = !state.isRefreshList;
      })
      .addCase(createReply.rejected, (state, action) => {
        state.isLoadingCreateReply = false;
      });

    // Delete reply
    builder
      .addCase(deleteEntry.pending, () => {})
      .addCase(deleteEntry.fulfilled, (state) => {
        state.isRefreshList = !state.isRefreshList;
      })
      .addCase(deleteEntry.rejected, () => {});
  },
});

// Actions
export const discussionAction = discussionSlice.actions;

// Reducer
const discussionReducer = discussionSlice.reducer;
export default discussionReducer;
